import React from "react";
import { useNavigate } from "react-router-dom";
import "./Common_Blog_card.css";

const Common_Blog_Card = ({ blog, handleBlogClick }) => {
  const navigate = useNavigate();

  // console.log("Common_Blog_Card", blog);

  return (
    <div className="blog_card" onClick={() => handleBlogClick(blog)}>
      <div className="blog_img_wrapper">
        <img
          src={process.env.REACT_APP_IMG_URL + blog.image}
          alt="blog"
          className="blog_img"
        />
      </div>

      <div className="blog_overlay">
        <h5 className="blog_title">{blog.name}</h5>

        <div className="blog_footer">
          <span className="blog_date">
            {new Date(blog.updatedAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </span>

          <span className="blog_link" onClick={() => handleBlogClick(blog)}>
            Start Reading
          </span>
        </div>
      </div>
    </div>
  );
};

export default Common_Blog_Card;
